import { Box, Fade, Typography } from '@mui/material';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import useIsFirstRender from '../../../../../../hooks/useIsFirstRender';
import useTeceoStyles from '../../../../../../useTeceoStyles';
import { useMessageNotificationSnackbarStyles } from './messageNotificationSnackbar.styles';
import { MessageNotificationSnackbarProps } from './messageNotificationSnackbar.types';

const CLEAN_TIMEOUT = 8000;

const MessageNotificationSnackbar = ({ messageInfo }: MessageNotificationSnackbarProps) => {
  const { classes: teceoClasses } = useTeceoStyles();
  const { classes } = useMessageNotificationSnackbarStyles();

  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [currentMessage, setCurrentMessage] = useState<string | undefined>(undefined);

  const isFirstRender = useIsFirstRender();

  useEffect(() => {
    if (isFirstRender) {
      return;
    }

    setIsVisible(true);
    setCurrentMessage(messageInfo?.text);

    const updateVisibleStateId = setTimeout(() => {
      setIsVisible(false);
    }, CLEAN_TIMEOUT - 400);
    const cleanCurrentMessageId = setTimeout(() => {
      setCurrentMessage(undefined);
    }, CLEAN_TIMEOUT);

    return () => {
      clearTimeout(updateVisibleStateId);
      clearTimeout(cleanCurrentMessageId);
    };
  }, [messageInfo?.updatedAt]);

  return (
    <Fade in={!!isVisible}>
      <Box className={classes.wrapper} test-id="chat-notification-snackbar-wrapper">
        <Typography className={classNames(classes.text, teceoClasses.truncate)}>
          {currentMessage}
        </Typography>
      </Box>
    </Fade>
  );
};

export default MessageNotificationSnackbar;
